import React, {useMemo} from "react";
import Glimmer from "@components/Glimmer";
import {useImageSize} from "@components/Booking/LocationSelection/LocationRow/Contents/Image/styles";

const ImageLoading = () => {
  const size = useImageSize();
  const style = useMemo(() => ({flexBasis: size, borderRadius: "0.5rem"}), [size]);
  return <Glimmer height={size} width={size} style={style} />;
};

export default React.memo(ImageLoading);
